type SearchResultsHeaderProps = {
  language: 'it' | 'en'
  searchTerm: string
  resultCount: number
}

const SearchResultsHeader = ({ language, searchTerm, resultCount }: SearchResultsHeaderProps) => {
  return (
    <header className="shop-surface rounded-2xl px-4 py-4 sm:px-5">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
        {language === 'en' ? 'Search results' : 'Risultati di ricerca'}
      </p>
      <h1 className="text-3xl font-bold tracking-tight text-slate-900">
        {searchTerm
          ? language === 'en'
            ? `Results for "${searchTerm}"`
            : `Risultati per "${searchTerm}"`
          : language === 'en'
          ? 'Search products'
          : 'Cerca prodotti'}
      </h1>
      <p className="text-sm text-slate-600">{language === 'en' ? `${resultCount} products` : `${resultCount} prodotti`}</p>
    </header>
  )
}

export default SearchResultsHeader
